import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Customer } from '../../types';
import { InfoItemDd, InfoItemDt, InfoItemList } from '../../common';
import CustomerInput from './CustomerInput';
import { useLocations } from '../../../settings/locations/locationsList/hooks';
import LocationsDropdown from '../../../components/Forms/LocationsDropdown';
import { useDispatch } from 'react-redux';
import { editCustomerField } from '../actions';
import debounce from 'lodash/debounce';

interface FavoriteStoreProps{
    customer: Customer;
    accountId: string;
}

const FavoriteStore = ({ customer, accountId }: FavoriteStoreProps) => {
    const { t }= useTranslation();
    const { locations, isLoading } =  useLocations();
    const favoriteLocation = (locations || []).find((location) => location.location_id === customer.favorite_store);
    const dispatch = useDispatch();
    const _editUser = (locationId: string) => {
        dispatch(editCustomerField(accountId, customer.customer_id, 'favorite_store', { 'favorite_store': locationId }));
    };

    const editUser = debounce(_editUser, 100);

    if (isLoading) {
        return null;
    }
    const locationNotSet = !customer.favorite_store;
    if (locations && locations.length > 0 && (favoriteLocation || locationNotSet)) {
        // Show dropdown if the location id is set or there are locations to choose from.
        return  <LocationsDropdown
            name="favorite_store"
            label={t('customers.fields.favorite_store')}
            value={favoriteLocation}
            options={locations}
            placeholder="N/A"
            onChange={(location) => {
                if (location) {
                    editUser(location.location_id || '');
                }
            }}
        />;
    }

    // If favorite store is not found in the locations, or no locations are set
    // (or the user has insufficient permissions to view locations), show editable ID
    return (
        <CustomerInput
            formElement="input"
            accountId={accountId}
            customer={customer}
            label={t('customers.fields.favorite_store')}
            name="favorite_store"
            type="text"
            value={customer.favorite_store}
            notSetValue="N/A"
        />);
};

export default FavoriteStore;
